const Fields = [
    {
        name: "owner",
        label: "Owner",
        type: ["const", "list"],
        invalid_values: [null, 'null', 'Null', 'NULL', 'None', 'none', 'NONE', 'NA', ''],
        to_lower: true,
        editable: true,
    },
    {
        name: "partner",
        label: "Partner",
        type: ["const", "list"],
        invalid_values: [null, 'null', 'Null', 'NULL', 'None', 'none', 'NONE', 'NA', ''],
        to_lower: true,
        editable: true,
    },
    {
        name: "property",
        label: "Property",
        type: ["const", "list"],
        invalid_values: [null, 'null', 'Null', 'NULL', 'None', 'none', 'NONE', 'NA', ''],
        to_lower: true,
        editable: true,
    },
    {
        name: "id_type",
        label: "ID Type",
        type: ["const", "list"],
        invalid_values: [null, 'null', 'Null', 'NULL', 'None', 'none', 'NONE', 'NA', ''],
        to_lower: true,
        editable: true,
    },
    {
        name: "id_format",
        label: "ID Format",
        type: ["const", "list"],
        invalid_values: [null, 'null', 'Null', 'NULL', 'None', 'none', 'NONE', 'NA', ''],
        to_lower: true,
        editable: true,
    }
];
export default Fields;